// 获取通用的隐私政策和用户协议
import request from "~/utils/request";
import {POLICY_INFO_URL, POLICY_LIST_URL, PROTOCAL_LIST_URL, TOOL_TIP_URL} from "~/api/api-list";

export function getGeneralContent(params) {
  return request({
    url: POLICY_INFO_URL,
    method: 'get',
    params: params,
    baseUrlType: 2
  });
}
// 获取通用的隐私政策和用户协议更新提示
export function getTooltip(params) {
  return request({
    url: TOOL_TIP_URL,
    method: 'get',
    params: params,
    baseUrlType: 2
  });
}

export function getPolicyList(params) {
  return request({
    url: POLICY_LIST_URL,
    method: 'get',
    params: params,
    baseUrlType: 2
  });
}

export function getProtocalList(params) {
  return request({
    url: PROTOCAL_LIST_URL,
    method: 'get',
    params: params,
    baseUrlType: 2
  });
}
